import React, { useState } from 'react';
import { FormControlLabelAndPopover } from '../FormControlLabel';
import { ValidationCheckMark, ValidationErrorsMessages } from '../FormValidation';

export const EmailinputControl = ({ field, handleChange, handleBlur, formDataEntry, errors } : ControlParameters) : JSX.Element => {
  const [isFocused, setIsFocused] = useState(false);
 
  const handleControlBlur = () => {
    setIsFocused(false);

    handleBlur({
      target: {
        name: field["@column"]
      }
    });
  }

  return (
  <div className={`form-group ${field.properties?.fieldcssclass ?? ''}`} key={field["@guid"]}>
    <FormControlLabelAndPopover field={field} loading={formDataEntry.loading} />
    <div className="input-group">
      <input
        type="email"
        className={"form-control" + (errors.length > 0 ? " is-invalid" : "") + (formDataEntry.touched ? " form-control--touched" : "")}
        name={field["@column"]}
        onBlur={handleControlBlur}
        onFocus={() => setIsFocused(true)}
        onChange={handleChange}
        required={!field["@allowempty"]}
        value={formDataEntry?.value ?? ""}
        title={field.properties.validationerrormessage}
        autoComplete={field.settings.Autocomplete ?? "off"}
      />
      <ValidationCheckMark required={!field["@allowempty"]} hasErrors={errors.length > 0} formDataEntry={formDataEntry} hasFocus={isFocused} />
    </div>
    {!isFocused && (<ValidationErrorsMessages keyGuid={field["@guid"]} errors={errors} />)}
  </div>
  );
};